import { inject, provideAppInitializer } from '@angular/core';
import { AppConfigService } from './app-config.service';

export const APP_CONFIG_INITIALIZER_PROVIDER = provideAppInitializer(() => {
  const appConfigService = inject(AppConfigService);
  return appConfigService.load();
});
